module.exports = __webpack_public_path__ + "img/polish@2x.04b9808.webp";